// const defaultSettings = require("./default-settings")
const defaultSettings = require("./default-settings");
// 根据环境引入不同配置 process.env.VUE_APP_ENV
// const environment = process.env.VUE_APP_ENV || 'production'
// const envConfig = require('./env.' + environment)
module.exports = {
  ...defaultSettings
  // env:envConfig
};
